(function () {
  if (window.__bcPicturedSelectInit) return;
  window.__bcPicturedSelectInit = true;

  function clean(s) {
    return String(s || '')
      .replace(/\s*\((?:as\s+)?(?:pictured|displayed)\)\s*/gi, '')
      .replace(/\s+(?:pictured|displayed)\s*$/i, '')
      .trim()
      .toLowerCase();
  }

  function picturedMeta() {
    var el = document.querySelector('[data-bc-pictured-size]');
    if (!el) return '';
    return clean(el.getAttribute('data-bc-pictured-size'));
  }

  function run() {
    if (!/\/products\//.test(location.pathname)) return;
    if (new URLSearchParams(location.search).get('variant')) return;
    var pictured = picturedMeta();
    if (!pictured || window.__bcPicturedSelectDone) return;

    var radios = document.querySelectorAll('input[data-product-variant][type="radio"]');
    if (radios.length) {
      var target = null;
      radios.forEach(function (inp) {
        if (clean(inp.value) === pictured) target = inp;
      });
      if (!target) return;
      window.__bcPicturedSelectDone = true;
      if (!target.checked) {
        target.click();
      } else {
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var items = document.querySelectorAll('[data-dropdown-list] [data-product-variant]');
    if (!items.length) return;
    var li = null;
    items.forEach(function (el) {
      if (clean(el.getAttribute('data-option-value')) === pictured) li = el;
    });
    if (!li) return;
    window.__bcPicturedSelectDone = true;
    if (!li.classList.contains('selected')) li.click();
  }

  function boot() {
    run();
    setTimeout(run, 80);
    setTimeout(run, 350);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
